import initialOpenDatabase from "../../IndexedDB/initialOpenDatabase";

const readPackageAccessResFromIndexedDB = async (
  keys = [
    "isLoggedIn",
    "mobileNumber",
    "accessibilities",
    "userId",
    "baseUserId",
    "username",
    "userTypeEnum",
    "organizationalTitles",
    "firstName",
    "lastName",
  ],
  dbName = "ERP_DB",
  storeNames = ["Client_Details", "Field_Access", "Enums", "List_Ui_State"],
  clientInfostoreName = "Client_Details",
  dbVersion = 1,
) => {
  try {
    // Open the database and start a readonly transaction
    const db = await initialOpenDatabase(dbName, storeNames, dbVersion);
    const transaction = db.transaction(clientInfostoreName, "readonly");
    const store = transaction.objectStore(clientInfostoreName);

    // Create a promise for each key fetch and resolve them in parallel
    const promises = keys.map(
      (key) =>
        new Promise((resolve, reject) => {
          const request = store.get(key);
          request.onsuccess = () => resolve({ key, value: request.result });
          request.onerror = () => reject(`Error reading key: ${key}`);
        }),
    );

    // Wait for all promises to resolve (all data fetched)
    const results = await Promise.all(promises);

    // Map the results into a key-value object
    const resultObj = results.reduce((acc, { key, value }) => {
      acc[key] = value;
      return acc;
    }, {});

    return resultObj; // Return the object containing all the key-value pairs
  } catch (error) {
    console.error("Error reading package access data:", error);
    throw error;
  }
};

export default readPackageAccessResFromIndexedDB;
